export default __webpack_public_path__ + "media/transretail.86eadd39.jpg";